import { customers } from '../../__mocks__';

export const getOrdersByDateAndCustomerId = () => {
  return Promise.resolve(customers.generateCustomers(20));
};
